import { CampaignFunction } from 'features/co-pilot/co-pilot.types';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';
import _ from 'lodash';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface PromptLibraryStore {
  promptLibraryOptions: OptionType[];
  campaignFunctions: CampaignFunction[];

  setPromptLibraryOptions: (functions: OptionType[] | null) => void;

  setCampaignFunctions: (functions: CampaignFunction[] | null) => void;
}

const usePromptLibraryStore = createWithEqualityFn<PromptLibraryStore>(
  (set) => ({
    promptLibraryOptions: [],
    campaignFunctions: [],

    setPromptLibraryOptions(functions: OptionType[] | null) {
      if (!_.isNil(functions)) {
        set(() => ({ promptLibraryOptions: functions }));
      } else {
        set(() => ({ promptLibraryOptions: [] }));
      }
    },

    setCampaignFunctions(functions: CampaignFunction[] | null) {
      if (!_.isNil(functions)) {
        set(() => ({ campaignFunctions: functions }));
      } else {
        set(() => ({ campaignFunctions: [] }));
      }
    },
  }),
  shallow
);

export default usePromptLibraryStore;
